import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Access from 'images/icons/smp_access.svg'
import PaymentBehavior from 'images/icons/smp_payment_behavior.svg'
import Security from 'images/icons/smp_security.svg'
import Trust from 'images/icons/smp_trust.svg'
import React, { FC } from 'react'
import { scopedTranslation } from 'src/helpers'

import { IconItem } from '../IconItem/IconItem'

const { t, htmlT } = scopedTranslation('component.smp.landing_page.advantages_section')

export const AdvantagesSection: FC = () => (
  <Box maxWidth='72rem' m='auto'>
    <Grid container={ true } spacing={ 2 }>
      <Grid item={ true } xs={ 12 }>
        <Box my={ 5 } textAlign='center'>
          <Typography variant='h2'>{ t('headline') }</Typography>
        </Box>
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 6 }>
        <IconItem
          iconSource={ Access }
          itemText={ htmlT('access_to_creditworthiness_data_html') }
        />
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 6 }>
        <IconItem
          iconSource={ Security }
          itemText={ t('security') }
        />
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 6 }>
        <IconItem
          iconSource={ PaymentBehavior }
          itemText={ t('better_payment_behavior') }
        />
      </Grid>
      <Grid item={ true } xs={ 12 } md={ 6 }>
        <IconItem
          iconSource={ Trust }
          itemText={ t('trust_in_business_relationships') }
        />
      </Grid>
    </Grid>
  </Box>
)
